
import { defineComponent, ref, watch, onMounted } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import Loading from "vue-loading-overlay";
import { Modal } from "bootstrap";
import AddFeaturesModal from "@/components/modals/forms/AddFeaturesModal.vue";
import { BILLED, PRICE_TYPE } from "../enum";
import { MasterPricing } from "../model/MasterPricing";
import { useToast } from "vue-toastification";
import ApiService from "@/core/services/ApiService";
import { useRoute, useRouter } from "vue-router";
import DayMonthPicker from "@/components/widgets/custom/DayMonthPicker.vue";
import "vue-loading-overlay/dist/vue-loading.css";

export default defineComponent({
  name: "Edit Feature",
  components: {
    Field,
    Form,
    AddFeaturesModal,
    ErrorMessage,
    DayMonthPicker,
    Loading,
  },
  setup() {
    const priceTypeEnum = ref(PRICE_TYPE);
    const priceType = [
      priceTypeEnum.value.FREE,
      priceTypeEnum.value.FIXED,
      priceTypeEnum.value.RECURRING,
    ];

    const billedTypeEnum = ref(BILLED);
    const billedType = [
      {
        key: billedTypeEnum.value.DAY.toLowerCase(),
        value: billedTypeEnum.value.DAY,
      },
      {
        key: billedTypeEnum.value.MONTH.toLowerCase(),
        value: billedTypeEnum.value.MONTH,
      },
      {
        key: billedTypeEnum.value.YEAR.toLowerCase(),
        value: billedTypeEnum.value.YEAR,
      },
    ];
    const isLoading = ref(false);
    const fullPage = ref(true);
    const isColor = "#007BFF";
    const isBackgroundColor = "#A3A3A3";
    const isOpacity = 0.5;
    const toast = useToast();
    const userStorage = ref(localStorage.getItem("user_account"));
    const currentUser = ref();
    const features = ref([]);
    const dataPricing = ref<MasterPricing>({
      price_title: "",
      description: "",
      price_type: "",
      price: 0,
      tax: 0,
      features: [],
      billing_setting: {
        billed: billedTypeEnum.value.DAY,
        billing_day: "0",
      },
      is_active: true,
    } as unknown as MasterPricing);

    const router = useRouter();
    const route = useRoute();

    if (userStorage.value) {
      currentUser.value = JSON.parse(userStorage.value);
    }

    const handleSubmit = () => {
      isLoading.value = true;
      dataPricing.value.features = features.value;

      ApiService.putWithData(
        `crmv2/main_feature/pricing-plans/${route.params._id}`,
        dataPricing.value
      )
        .then((res) => {
          console.log(res);
          toast.success("Data berhasil disimpan");
        })
        .catch((e) => {
          console.log(e);

          if (e.response.status == 401) {
            toast.error(e.response.data.detail);
            router.push("/sign-in");
            isLoading.value = false;
          } else {
            toast.error("Something went wrong");
            isLoading.value = false;
          }
        })
        .finally(() => {
          isLoading.value = false;
          router.push("/superadmin/master-feature/pricing");
        });
    };

    const handleAddFeature = (data) => {
      features.value = data;
    };
    const formatPrice = (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    const capitalizeBilled = (str) => {
      if (!str) return "";
      if (str === "daily") return "Day";
      return str.charAt(0).toUpperCase() + str.slice(1).slice(0, -2);
    };
    const getData = () => {
      isLoading.value = true;
      const id = route.params._id;
      ApiService.getWithoutSlug("crmv2/main_feature/pricing-plans/" + id)
        .then((res) => {
          dataPricing.value = res.data.data;
          features.value = res.data.data.features;
          isLoading.value = false;
        })
        .catch((e) => {
          console.log(e);
          toast.error("Error Fetching data");
          isLoading.value = false;
        });
    };

    const isRequired = (value) => {
      if (!value) {
        return "Field ini wajib diisi";
      }
      return true;
    };

    const removeModule = (index) => {
      features.value.splice(index, 1);
    };

    const items = ref([
      { id: 1, name: "User Management" },
      { id: 2, name: "Analytics Dashboard" },
    ]);

    // watch(
    //   () => dataPricing.value.billing_setting.billed,
    //   (newVal, oldVal) => {
    //     console.log("asdasd");
    //   }, {deep: true}
    // );

    watch(dataPricing.value, (newValue) => {
      if (dataPricing.value.price_type === priceTypeEnum.value.FREE) {
        dataPricing.value.billing_setting.billed = "";
        dataPricing.value.billing_setting.billing_day = "0";
        dataPricing.value.billing_setting.billing_due_day = 0;
        dataPricing.value.price = 0;
        dataPricing.value.tax = 0;
      } else if (dataPricing.value.price_type === priceTypeEnum.value.FIXED) {
        dataPricing.value.billing_setting.billed = "";
        dataPricing.value.billing_setting.billing_day = "0";
        dataPricing.value.billing_setting.billing_due_day = 0;
      }
    });

    return {
      isLoading,
      fullPage,
      isColor,
      isBackgroundColor,
      isOpacity,
      items,
      priceType,
      dataPricing,
      priceTypeEnum,
      billedTypeEnum,
      billedType,
      features,
      formatPrice,
      handleAddFeature,
      handleSubmit,
      isRequired,
      getData,
      removeModule,
      capitalizeBilled,
    };
  },
  mounted() {
    this.getData();
  },
});
